import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    barContainer: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        paddingBottom: theme.spacing(3),
    },
    barWrapper: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    progressBarWidth: {
        width: "100%",
    },
    progressBarWithNameWidth: {
        width: "80%",
    },
    progressBar: {
        display: "flex",
        alignItems: "center",
        padding: `${theme.spacing(4)} ${theme.spacing(2)}`,

        "&> div:first-child": {
            borderTopLeftRadius: 50,
            borderBottomLeftRadius: 50,
        },

        "&> div:last-child": {
            borderTopRightRadius: 50,
            borderBottomRightRadius: 50,
        },

        "&> div:not(:last-child)": {
            marginRight: theme.spacing(1),
        },
    },
    progressBarSection: {
        height: 25,
        textAlign: "right",
    },
    completeOnTimeBar: {
        backgroundColor: theme.palette.success.main,
        position: "relative",
    },
    amount: {
        position: "absolute",
        bottom: 30,
        right: 10,
        "&> h5": {
            fontSize: "12px !important",
        },
    },
    completeOnTimeIcon: {
        color: theme.palette.success.main,
    },
    pendingBar: {
        backgroundColor: theme.palette.warning.dark,
        position: "relative",
    },
    pendingIcon: {
        color: theme.palette.warning.dark,
    },
    completeLateBar: {
        backgroundColor: theme.palette.warning.main,
        position: "relative",
    },
    completeLateIcon: {
        color: theme.palette.warning.main,
    },
    pendingLateBar: {
        backgroundColor: theme.palette.error.main,
        position: "relative",
    },
    pendingLateIcon: {
        color: theme.palette.error.main,
    },
    amountsContainer: {
        width: "100%",
    },
    referencesContainer: {
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
    },
    referenceItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: theme.spacing(4),
    },
    referenceIcon: {
        fontSize: "12px !important",
    },
    referenceTitle: {
        fontSize: "12px !important",
    },
    noData: {
        "&> div": {
            height: "76px !important",
        },
    },
    avatarWrapper: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        width: "20%",
        justifyContent: "flex-start",
        paddingLeft: theme.spacing(2),
    },
    avatar: {
        width: `27.5px !important`,
        height: `27.5px !important`,
    },
    border: {
        borderBottom: `1px solid ${theme.palette.corporateBO.checkboxTrackChecked}`,
    },
    percentageReferenceContainer: {
        width: "100%",
        marginBottom: theme.spacing(4),
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
    },
    percentageReference: {
        border: `1px solid ${theme.palette.corporateBO.checkboxTrackChecked}`,
        width: "100%",
    },
    percentageNumbers: {
        width: "80%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "& h5": {
            margin: "unset",
            fontSize: "12px",
            color: theme.palette.primary.dark,
        },
    },
}));
